var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 18H6.1875C5.79916 18 5.48438 17.6852 5.48438 17.2969C5.48438 16.9085 5.79916 16.5938 6.1875 16.5938H11.8125C12.2008 16.5938 12.5156 16.9085 12.5156 17.2969C12.5156 17.6852 12.2008 18 11.8125 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.4688C8.61166 15.4688 8.29688 15.154 8.29688 14.7656C8.29688 14.0729 7.43143 13.3599 6.42938 12.5344C4.70201 11.1113 2.67188 9.39238 2.67188 6.32812C2.67188 2.8388 5.51067 0 9 0C12.4893 0 15.3281 2.8388 15.3281 6.32812C15.3281 9.31535 13.4145 10.9889 11.6019 12.474C10.5831 13.3089 9.70312 14.0299 9.70312 14.7656C9.70312 15.154 9.38834 15.4688 9 15.4688ZM9 1.40625C6.28608 1.40625 4.07812 3.6142 4.07812 6.32812C4.07812 8.77535 5.80229 10.1958 7.3235 11.449C7.94225 11.9587 8.54367 12.4542 8.98706 12.9948C9.44002 12.4274 10.066 11.9145 10.7106 11.3863C12.2159 10.153 13.9219 8.75514 13.9219 6.32812C13.9219 3.6142 11.7139 1.40625 9 1.40625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.84375C7.06145 9.84375 5.48438 8.26664 5.48438 6.32812C5.48438 4.38961 7.06145 2.8125 9 2.8125C10.9386 2.8125 12.5156 4.38961 12.5156 6.32812C12.5156 8.26664 10.9386 9.84375 9 9.84375ZM9 4.21875C7.83689 4.21875 6.89062 5.16502 6.89062 6.32812C6.89062 7.49123 7.83689 8.4375 9 8.4375C10.1631 8.4375 11.1094 7.49123 11.1094 6.32812C11.1094 5.16502 10.1631 4.21875 9 4.21875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.05cfea1709f8895e6ca7893d253c464e.svg";
export { ForwardRef as ReactComponent };